<a class="banner-icon" [matMenuTriggerFor]="appMenu" matTooltip="Menu" matTooltipPosition="below">
    <fa-icon [icon]="menuIcon"></fa-icon>
</a>
<mat-menu #appMenu="matMenu" class="avmup-menu">
    @if (editProfilRight) {
        <a class="avmup-menu-item mat-mdc-menu-item mat-mdc-menu-item" (click)="openProfileSettings()">
            <fa-icon [icon]="profilIcon"></fa-icon>
            Paramétrage du profil
        </a>
    }
    <a class="avmup-menu-item mat-mdc-menu-item">
        <fa-icon [icon]="handbookIcon"></fa-icon>
        Guide Utilisateur
    </a>
    <a class="avmup-menu-item mat-mdc-menu-item">
        <fa-icon [icon]="handbookIcon"></fa-icon>
        Guide Administrateur
    </a>
    @if (supervisionRight && supervisionSubscription) {
        <a class="avmup-menu-item mat-mdc-menu-item" (click)="openSupervision()">
            <fa-icon [icon]="dashboardIcon"></fa-icon>
            Supervision
        </a>
    }
    <a class="avmup-menu-item mat-mdc-menu-item">
        <fa-icon [icon]="faqIcon"></fa-icon>
        FAQ
    </a>
    <a class="avmup-menu-item mat-mdc-menu-item" (click)="modifyPassword()">
        <fa-icon [icon]="faKey"></fa-icon>
        <span>Changer mot de passe</span>
    </a>
    <a class="avmup-menu-item mat-mdc-menu-item" (click)="openAbout()">
        <fa-icon [icon]="aboutIcon"></fa-icon>
        A Propos
    </a>
</mat-menu>
